import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default ({ children, ...props }) => (
  <li className="relative pl-6" {...props}>
    <FontAwesomeIcon className="text-sm absolute left-0 mt-1" icon="check" fixedWidth />
    {children}
  </li>
)
